import {Component, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {takeUntil} from "rxjs/operators";
import {Subject} from "rxjs";
import {ModalComponent} from "@pb-labs/modal";
import {ButtonType} from "@pb-labs/button";
import {FileUploadModalService} from "./file-upload-modal.service";
import {fileUploadModalActions} from "@app/modules/browse/components/shared/file-upload-modal/const";
import {FileUploadModalLayoutService} from "@app/modules/browse/components/shared/file-upload-modal/layout/file-upload-modal-layout.service";

@Component({
  selector: "app-file-upload-modal",
  templateUrl: "./file-upload-modal.component.html",
  styleUrls: ["./file-upload-modal.component.scss"],
})
export class FileUploadModalComponent implements OnInit, OnDestroy {
  @ViewChild("modal") modal: ModalComponent;

  selectedFile: File = null;
  readonly fileUploadModalActions = fileUploadModalActions;
  readonly buttonType = ButtonType;
  private _destroy$: Subject<void> = new Subject<void>();

  constructor(
    private fileUploadModalService: FileUploadModalService,
    private fileUploadModalLayoutService: FileUploadModalLayoutService
  ) {}

  get fileUploading(): boolean {
    return this.fileUploadModalService.isFileUploading;
  }

  get fileValidationMessage(): string {
    return this.fileUploadModalService.validationErrorMessage;
  }

  ngOnInit(): void {
    this.fileUploadModalService.open$.pipe(takeUntil(this._destroy$)).subscribe(() => {
      this.fileUploadModalLayoutService.openModal();
    });

    this.fileUploadModalService.close$.subscribe(() => {
      this.fileUploadModalLayoutService.closeModal();
    });

    this.fileUploadModalService.selectedFile$.pipe(takeUntil(this._destroy$)).subscribe((selectedFile: File) => {
      this.selectedFile = selectedFile;
    });
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  isUploadedFileInvalid(): boolean {
    return !!this.fileValidationMessage;
  }

  clearFile(): void {
    this.fileUploadModalService.clearFile();
  }

  onFileSelect(file: File): void {
    if (file) {
      this.fileUploadModalService.onFileSelect(file);
    } else {
      this.clearFile();
    }
  }

  onCloseIconClick() {
    this.fileUploadModalService.verify(fileUploadModalActions.Cancel);
  }

  isCloseIconDisabled(): boolean {
    return this.fileUploading;
  }

  onButtonClick(action: fileUploadModalActions): void {
    this.fileUploadModalService.verify(action);
  }

  isUploadButtonDisabled(): boolean {
    return !this.selectedFile || this.isUploadedFileInvalid();
  }

  isUploadButtonBusy(): boolean {
    return this.fileUploading;
  }

  isCancelButtonDisabled(): boolean {
    return this.fileUploading;
  }
}
